import React from 'react';
import { map, get, filter, includes, flatten, find, size, compact } from 'lodash';
import { func, array, number } from 'prop-types';
import { Row, Column, Icon, FormSelect } from '../../../../common';
import { typeQuestions } from '../../../../../utils/misc';

const Condition = ({
    removeCondition,
    condition,
    conditions,
    updateQuestions,
    options,
    typeQuestion,
    questionsFromCurrentPosition
}) => {
    const idNextQuestionSelected = get(condition, 'idNextQuestion');
    const nextQuestionSelected = filter(questionsFromCurrentPosition, { value: idNextQuestionSelected });
    const currentConditionId = get(condition, 'idCondition');
    const isMultiple = typeQuestion === typeQuestions.MULTIPLE;
    const optionsSelected = find(options, ({ value }) => includes(flatten([get(condition, 'idOptions')]), value));
    const updateCondition = (idNextQuestion, options) => {
        const updatedConditions = map(conditions, (condition) => {
            return get(condition, 'idCondition') === currentConditionId
                ? { ...condition, idOptions: isMultiple ? map(options, 'value') : options, idNextQuestion }
                : condition;
        });

        updateQuestions('conditions', updatedConditions);
    };

    const filterQuestions = () => {
        const idNextQuestions = map(conditions, 'idNextQuestion');
        const questionsWithoutAssociation = filter(questionsFromCurrentPosition, ({ value }) =>
            !includes(idNextQuestions, value) || value === idNextQuestionSelected
        );

        return questionsWithoutAssociation;
    };

    const filterOptions = () => {
        const idOptionsFromCurrentCondition = map(conditions, 'idOptions')
        return filter(options, ({ value }) => !includes(idOptionsFromCurrentCondition, value) || value === get(optionsSelected, 'value'));
    };

    const getOptionSelected = () =>
        isMultiple ? optionsSelected : get(optionsSelected, 'value');

    return <Column backgroundColor='white' borderRadius={4} padding={15}>
        <Row justify='flex-end'>
            <Icon name='new-trash' color='#1fa02e' size={23} pointer onClick={removeCondition} />
        </Row>
        <Row gap={10}>
            <Row>
                <FormSelect
                    multiple={isMultiple}
                    label='La respuesta es'
                    options={filterOptions()}
                    value={optionsSelected}
                    onChange={({ value }) => updateCondition(idNextQuestionSelected, isMultiple ? value : get(value, 'value'))}
                    style={{ margin: 0 }}
                />
            </Row>
            <Row>
                <FormSelect
                    label='Saltar a'
                    options={questionsFromCurrentPosition}
                    value={nextQuestionSelected}
                    onChange={({ value }) => updateCondition(get(value, 'value'), getOptionSelected())}
                    style={{ margin: 0 }}
                />
            </Row>
        </Row>
    </Column>;
};

Condition.propTypes = {
    removeCondition: func,
    condition: array,
    conditions: array,
    updateQuestions: func,
    options: array,
    typeQuestion: number,
    questionsFromCurrentPosition: array
};

export default Condition;
